/**
 * Phase 10e — Badge visuel indiquant la source d'une facture fournisseur.
 *
 * Affiché sur la liste ET la fiche détail. Compact (icône + label courte).
 *   - peppol_inbound → "Peppol" (bleu ciel)
 *   - manual         → "Manuelle" (gris slate)
 *   - test_fixture   → "Test" (violet, uniquement en preview / dev)
 */
import { Badge } from "@/components/ui/badge";
import { Radio, Upload, FlaskConical } from "lucide-react";

const CONFIG = {
  peppol_inbound: {
    label: "Peppol",
    icon: Radio,
    cls: "border-sky-500/40 bg-sky-500/10 text-sky-300",
  },
  manual: {
    label: "Manuelle",
    icon: Upload,
    cls: "border-slate-500/40 bg-slate-500/10 text-slate-300",
  },
  test_fixture: {
    label: "Test",
    icon: FlaskConical,
    cls: "border-purple-500/40 bg-purple-500/10 text-purple-300",
  },
};

export default function SupplierInvoiceSourceBadge({ source, size = "sm" }) {
  const cfg = CONFIG[source] || CONFIG.peppol_inbound;
  const Icon = cfg.icon;
  const iconSize = size === "xs" ? "h-2.5 w-2.5" : "h-3 w-3";
  const textSize = size === "xs" ? "text-[10px]" : "text-xs";
  return (
    <Badge
      className={`inline-flex items-center gap-1 border font-normal ${textSize} ${cfg.cls}`}
      data-testid={`source-badge-${source || "peppol_inbound"}`}
    >
      <Icon className={iconSize} />
      {cfg.label}
    </Badge>
  );
}
